import { API_URLS } from "@/config/urls";

// 任意の入力（相対/絶対）を「絶対URL」に解決する
export const toAbsoluteUrl = (
  toPathOrUrl: string,
  baseOrigin = window.location.origin,
) => {
  try {
    return new URL(toPathOrUrl).toString(); // 既に絶対URL
  } catch {
    return new URL(toPathOrUrl, baseOrigin).toString(); // 相対→絶対
  }
};

// 登録画面へ（to=相対/絶対どちらでもOK）
export const redirectToRegisterWithReturn = (toPathOrUrl: string) => {
  const to = toAbsoluteUrl(toPathOrUrl);
  window.location.href = `${API_URLS.WHALE}/auth/register?to=${encodeURIComponent(to)}`;
};

// ログイン画面へ（to=相対/絶対どちらでもOK）
export const redirectToLoginWithReturn = (toPathOrUrl: string) => {
  const to = toAbsoluteUrl(toPathOrUrl);
  window.location.href = `${API_URLS.WHALE}/auth/login?to=${encodeURIComponent(to)}`;
};

export const navigateToOidcLogout = (logoutUrl: string) => {
  window.location.href = logoutUrl;
};
